import type { MouseEvent, ReactElement } from 'react';

/** 누를 때 입력 칸의 포커스를 빼앗지 않는다 — 빼앗으면 칸을 떠나며 입력이 먼저 적용된 뒤 취소된다. */
const keepFocus = (event: MouseEvent<HTMLButtonElement>): void => event.preventDefault();

interface PendingInputNoticeProps {
  /** 적용하지 않은 입력을 모두 버리고 사이드바 입력을 저장된 값으로 되돌린다. */
  readonly onCancel: () => void;
  /** 그리기 대상이 있으면 그리기를 그만두는 버튼도 함께 둔다(그리기 쪽 막힘 안내 대신). */
  readonly onCancelDrawing?: () => void;
}

/**
 * 사이드바에 적용하지 않은 입력이 있어 사진 조작이 막혔을 때의 안내(설계 §12-3).
 * 그리기가 막혔을 때의 ShapeDrawingBlockedNotice 와 같은 모양으로, 운영자가 입력을 버리고 바로 조작할 수 있게 한다.
 */
export const PendingInputNotice = ({
  onCancel,
  onCancelDrawing,
}: PendingInputNoticeProps): ReactElement => (
  <div className="flex flex-wrap items-center gap-2 text-sm">
    <p role="status" className="text-muted-foreground">
      적용하지 않은 입력을 먼저 적용하거나 취소한 뒤 조작할 수 있습니다.
    </p>
    <button
      type="button"
      className="rounded border px-2 py-1"
      onMouseDown={keepFocus}
      onClick={onCancel}
    >
      입력 취소
    </button>
    {onCancelDrawing === undefined ? null : (
      <button
        type="button"
        className="rounded border px-2 py-1"
        onMouseDown={keepFocus}
        onClick={onCancelDrawing}
      >
        그리기 취소
      </button>
    )}
  </div>
);
